/* @ngInject */
const railwayFields = (
  railwayLabels,
  railwayGo,
  $$area,
  types,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',
    label: railwayLabels.fields.id.text,
    icon: icons.railway.id,
    output: false,
  }

  self.selectRailway = {
    ref: 'selectRailway',
    label: railwayLabels.fields.selectRailway.text,
    type: types.select,
    options: 'railway as railway.number for railway',
    order: 'number.toString()',
    choice: railwayLabels.fields.selectRailway.choice,
    messages: railwayLabels.fields.selectRailway.messages,
    required: true,
    output: false,
  }

  self.selectId = {
    ref: 'selectId',
    label: railwayLabels.fields.selectId.text,
    type: types.select,
    options: 'railway.id as railway.number for railway',
    order: 'number.toString()',
    choice: railwayLabels.fields.selectId.choice,
    messages: railwayLabels.fields.selectId.messages,
    required: true,
    output: false,
  }

  self.number = {
    ref: 'number',
    label: railwayLabels.fields.number.text,
    icon: icons.railway.number,
    type: types.text(),
    required: true,
    unique: true,
    nature: 'railway',
    messages: railwayLabels.fields.number.messages,
    output: {
      sortable: true,
      link: true,
      go: railwayGo.consult,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
      class: { 'table-fix-left': true, },
    },
  }

  self.areaName = {
    ref: 'areaName',
    label: railwayLabels.fields.area.text,
    output: {
      sortable: true,
      link: true,
      go: $$area.go.consult,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.areaId = {
    ref: 'areaId',
    label: railwayLabels.fields.area.text,
    icon: icons.railway.area,
    type: types.select,
    options: 'area.id as area.name for area',
    order: 'name.toString()',
    required: true,
  }

  self.length = {
    ref: 'length',
    label: railwayLabels.fields.length.text,
    icon: icons.railway.length,
    type: types.decimal,
    required: true,
    messages: railwayLabels.fields.length.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: true, },
    },
  }

  self.availableLength = {
    ref: 'availableLength',
    label: railwayLabels.fields.availableLength.text,
    icon: icons.railway.length,
    output: {
      sortable: true,
      excel: false,
    },
  }

  self.usedLength = {
    ref: 'usedLength',
    label: railwayLabels.fields.usedLength.text,
    icon: icons.railway.length,
    output: {
      sortable: true,
      excel: false,
    },
  }

  self.ratioUsedLength = {
    ref: 'ratioUsedLength',
    label: railwayLabels.fields.ratioUsedLength.text,
    icon: icons.railway.length,
    output: {
      sortable: false,
      table: { prefill: true, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.ratioAvailableLength = {
    ref: 'ratioAvailableLength',
    label: railwayLabels.fields.ratioAvailableLength.text,
    icon: icons.railway.length,
    output: {
      sortable: false,
      table: { display: true, prefill: true, },
      details: { display: true, },
      excel: { display: true, prefill: false, },
    },
  }

  self.wagonCount = {
    ref: 'wagonCount',
    label: railwayLabels.fields.wagonCount.text,
    icon: icons.railway.wagonCount,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
      excel: { prefill: true, },
    },
  }

  self.left = {
    ref: 'left',
    label: railwayLabels.fields.left.text,
    icon: icons.railway.left,
    type: types.text(),
    required: true,
    messages: railwayLabels.fields.left.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.right = {
    ref: 'right',
    label: railwayLabels.fields.right.text,
    icon: icons.railway.right,
    type: types.text(),
    required: true,
    messages: railwayLabels.fields.right.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      details: true,
      excel: { prefill: false, },
    },
  }

  self.badge = {
    ref: 'badge',
    label: railwayLabels.fields.badge.text,
    icon: icons.railway.area,
  }

  return self
}
export default railwayFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/resources/fields.resource.js